import React from "react";

const CheckBoardIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M7.75781 12.7501L9.00781 14.0001L12.3411 10.6667"
        stroke={color}
        strokeOpacity="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33317 5.50008H11.6665C13.3332 5.50008 13.3332 4.66675 13.3332 3.83341C13.3332 2.16675 12.4998 2.16675 11.6665 2.16675H8.33317C7.49984 2.16675 6.6665 2.16675 6.6665 3.83341C6.6665 5.50008 7.49984 5.50008 8.33317 5.50008Z"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 3.8501C16.1083 4.0001 17.5 5.0251 17.5 8.83343V13.8334C17.5 17.1668 16.6667 18.8334 12.5 18.8334H7.5C3.33333 18.8334 2.5 17.1668 2.5 13.8334V8.83343C2.5 5.03343 3.89167 4.0001 6.66667 3.8501"
        stroke={color}
        strokeOpacity="0.8"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckBoardIcon;
